import { useCallback, useRef } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

interface EditorButtonAttachmentProps extends EditorButtonProps {
  onUpload: (files: File[]) => void;
}

export const EditorButtonAttachment = ({ onUpload }: EditorButtonAttachmentProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleUpload = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = [...(e.target.files ?? [])];
      onUpload(files);
      inputRef.current!.value = ""; // Reset the input value to allow multiple uploads
    },
    [onUpload]
  );

  return (
    <>
      <EditorButton icon="attach_file" onClick={() => inputRef.current?.click()} tooltip="Attach file" />
      <input type="file" multiple onChange={handleUpload} ref={inputRef} className="hidden" />
    </>
  );
};
